// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderAddTwoToneSvg from "@ant-design/icons-svg/es/asn/FolderAddTwoTone";
import AntdIcon from '../components/AntdIcon';

var FolderAddTwoTone = function FolderAddTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderAddTwoToneSvg
  }));
};

FolderAddTwoTone.displayName = 'FolderAddTwoTone';
export default React.forwardRef(FolderAddTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FolderAddTwoTone.js
// module id = 1191
// module chunks = 0